import { render, staticRenderFns } from "./UserJobInfoTab.vue?vue&type=template&id=543dda00&scoped=true&"
import script from "./UserJobInfoTab.vue?vue&type=script&lang=js&"
export * from "./UserJobInfoTab.vue?vue&type=script&lang=js&"
import style0 from "./UserJobInfoTab.vue?vue&type=style&index=0&id=543dda00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543dda00",
  null
  
)

export default component.exports